export default {
  de: {
    factories: 'Betriebe',
    factory: 'Betrieb',
    name: 'Name',
    additions: 'Zuschläge',
    searchPigSty: 'Betriebname, Ring Nr., LFBIS eingeben...',
    street: 'Straße',
    selectPigSty: 'Standort auswählen',
    pigSty: 'Standort',
    link: 'Betrieb öffnen',
    notification: {
      create: {
        type: 'success',
        message: 'Betrieb erfolgreich angelegt',
        title: 'Erfolgreich angelegt'
      },
      update: {
        type: 'success',
        message: 'Betrieb erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      }
    }
  }
}
